import type { DateTime } from 'luxon'
import type { DeepNullable } from '~/models/Utilities'
import type { UserRole } from '~/models/User/UserRole'
import type { SubjectCode } from '~/models/Subject'
import type { GradeCode } from '~/models/Grade'
import type { FavoriteList } from '~/models/Favorites'

export enum TaskStatus {
  Open = 'OPEN',
  Closed = 'CLOSED',
}

export enum LocationType {
  Location = 'LOCATION',
  ParentLocation = 'PARENT_LOCATION',
}

export interface Response {
  response: Array<Task>
  resultCount: number
}

type TaskNullableParts = DeepNullable<{
  taskId: string
  name: string
  grades: GradeCode[]
  subjects: SubjectCode[]
  groups: string[]
  locationIds: number[]
  taskLocationIds: number[]
  users: TaskUser[]
  locationType: LocationType
  pathString: string
  status: TaskStatus
  duration: number
  tags: string[]
  createdAt: string
  createdBy: string
  creator: Pick<TaskUser, 'firstName' | 'fullName' | 'lastName'>
  updatedAt: string
  updatedBy: string
  message?: string
  week?: number
  favoriteList?: Partial<FavoriteList>
  homework?: boolean
}>

export type Task = TaskNullableParts & {
  startDate?: DateTime
}

export interface StrictTaskUser {
  userId: string
  status: TaskStatus
  firstName: string
  lastName: string
  fullName: string
  primaryRole: UserRole
}

export type TaskUser = DeepNullable<StrictTaskUser>

export interface TaskUserRequest {
  users: Pick<TaskUser, 'userId' | 'status'>[]
}

export interface TaskQueryParams {
  groups?: string[]
  tags?: string[]
  subjects?: string[]
  grades?: string[]
  week?: number
  favoriteListId?: string
  [key: string]: string[] | string | number | undefined
}
